import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ListagemHeader from '../../../components/gww-lib/listagens-header/index';
import NavBar from '../../../components/layout/navbar/index';


function ListaNfce({ history }) {

    function vaiNfe(registroUnico) {
        history.push('/cadastro-nfce', { registroUnico });
    }

    const columns = {
        dic: [
            { id: 'CNRNF', label: 'Código Nota', minWidth: 10 },
            { id: 'CNRFORM', label: 'Formulário', minWidth: 10 },
            { id: 'CDSPESS', label: 'Cliente', minWidth: 10 },
            { id: 'DDTENISS', label: 'Data Emissão', minWidth: 10 },
            { id: 'LAUTORIZADA', label: 'Autorizada', minWidth: 10 },
            { id: 'LCANCELADA', label: 'Cancelada', minWidth: 10 },
            { id: 'LDENEGADA', label: 'Denegada', minWidth: 10 },
            { id: 'LINUTILIZADA', label: 'Inutilizada', minWidth: 10 },
        ]
    };


    let filtrosGrupoImposto = {
        dic: [
            {
                campoFiltro: "CNRNF",
                descricaoFiltro: "NR Nota",
            },
            {
                campoFiltro: "CNRFORM",
                descricaoFiltro: "Formulario",
            },
            {
                campoFiltro: "CCDPESS",
                descricaoFiltro: "Cliente",
            },
            {
                campoFiltro: "DDTEMISS",
                descricaoFiltro: "Emissão",
            },
        ],
    };



    return (
        <Fragment>
            <NavBar />
            <ListagemHeader
                filtros={filtrosGrupoImposto}
                columns={columns}
                tela="ListaNfce"
                titulo="NFc-e"
                nomeChave="PCNRNF"
                metodoListagem="WEBSITE_LISTAGEM_NFCE"
                metodoConsultaUnica="WEBSITE_NFCE_BYID"
                vaiPara={(registro) => vaiNfe(registro)}
            />
        </Fragment>
    )
}

export default withRouter(ListaNfce);